import { RequestModels } from 'models/request.models';

export const RequestStatesAllowingCreation = [
  RequestModels.RequestStateEnum.Rejected,
  RequestModels.RequestStateEnum.Cancelled,
];
